import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const StepErrorWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "step-error",
})`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(to top, #ffffff 50%, #2e005d 50%);
  font-family: sans-serif;
  direction: rtl;

  .bus-image {
    width: 100%;
    max-width: 500px;
    height: auto;
  }

  .content-box {
    margin-top: 2rem;
    background: white;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
    max-width: 90%;
    width: 400px;
  }

  .logo {
    width: 60px;
    margin-bottom: 1rem;
  }

  .success-icon {
    font-size: 2rem;
    color: green;
  }

  .header {
    margin: 1rem 0;
    color: #333;
  }

  .sub-text {
    color: #666;
    font-size: 0.95rem;
  }

  .app-links {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    gap: 1rem;
  }

  .app-links img {
    height: 40px;
  }
`;
